import { Box, Typography } from "@mui/material";
import React from "react";
import styled from "@emotion/styled";
import { useTranslation } from "hhn-commons";
import theme from "../theme";

const EmptyRecordView = ({ emptyMessage }: { emptyMessage?: string }) => {
  const { t } = useTranslation();
  const message = emptyMessage ?? t("emptyRecordMessage");
  const EmptyRecordViewContainer = styled(Box)`
    display: flex;
    margin: 4px 0;
    background: ${theme.palette.grey[100]};
    align-items: center;
    align-content: space-between;
    justify-content: center;
    height: 54px;
  `;
  return (
    <EmptyRecordViewContainer>
      <Typography variant={"subtitle1"} data-testid="empty-record">
        {message}
      </Typography>
    </EmptyRecordViewContainer>
  );
};

export default EmptyRecordView;
